import { PqdSqlClient } from '../sqlite/pdq-sqlite-client';
import { Mutex } from '../utils';
import Debug from 'debug';
import { Subject } from 'rxjs';
const log = Debug('pdq:sqlite:SqliteBroker');

const currentScriptUrl = new URL(import.meta.url);
const scriptPath = currentScriptUrl.pathname;
const scriptDir = scriptPath.substring(0, scriptPath.lastIndexOf('/'));

export class SqliteBroker {
  private _client = new Map<string, PqdSqlClient>
  private _mutex = new Mutex('SqliteBroker');
  private _baseUrl = scriptDir

  private tableUpdatedSubject = new Subject<{database: string, table: string}>()
  private _tableUpdatedSubject= this.tableUpdatedSubject.asObservable()
  get tableUpdated() {return this._tableUpdatedSubject}

  constructor() {
    this._tableUpdatedSubject.subscribe(i => {
      log(`table updated`, i)
    })
  }

  async info() {
    console.log('getting: SQLITE BROKER INFO', Array.from(this._client.keys()));
    const res = await Promise.all([...this._client.keys()].map(async key   => {
      const client = this._client.get(key)!;
      const info = await client.query('SELECT * FROM sqlite_master')
      return info.map(i => ({database: key, ...i}))
    }))
    console.table(res.flat())
  }

  async getDatabaseClient(path: string, alias: string = 'main', note: string = '-'): Promise<PqdSqlClient> {
    log(`getDatabaseClient`, path, alias, note)
    const unlock = await this._mutex.lock()
    try {
      let client = this._client.get(path)
      if (!client) {
        log(`creating new client for ${path}`);
        client = new PqdSqlClient(path, this._baseUrl);
        this._client.set(path, client)
      }
      return client
    } finally {
      unlock()
    }
  }
  notifyTableUpdated(database: string, table: string) {
    this.tableUpdatedSubject.next({database, table})
  }
  #databasesReadyMap = new Map<string, {promise: Promise<void>, resolve: () => void }>()
  getDatabaseReadyPromise(opfsPath: string) {
    let existing = this.#databasesReadyMap.get(opfsPath)
    if (existing)
      return existing.promise

      let resolve = () => {};
      const promise = new Promise<void>(r => resolve = r)
      this.#databasesReadyMap.set(opfsPath, {promise, resolve})
      return promise
  }
  setDatabaseReady(opfsPath: string) {
    log(`setDatabaseReady:${opfsPath}`)
    let existing = this.#databasesReadyMap.get(opfsPath)
    if (existing)
      return existing.resolve()

    let resolve = () => {};
    const promise = new Promise<void>(r => resolve = r)
    this.#databasesReadyMap.set(opfsPath, {promise, resolve})
    resolve()
  }

  forceTerminateAllSqlite(){
    this._client.forEach(c => c.forceTerminate())
    location.reload()
  }
  forceTerminateAllSqliteAndReloadPage(){
    this._client.forEach(c => c.forceTerminate())
    location.reload()
  }
}

export const sqliteBroker = new SqliteBroker();
log(`SqliteBroker created`)